<template>
  <div class="main" >
    <!-- 中间 -->
    <div>
      <div
        class="ant-spin-nested-loading"
        style="width: 100%; min-height: 700px"
      >
        <div class="ant-spin-container">
          <div class="page box-info">
            <div class="case-container app-container">
              <div class="case"  v-show="iscase">
                <div class="case__info">
                  <div
                    class="case__info__arrow"
                    style="
                      background-image: url(' ');
                    "
                  ></div>
                  <div class="case__picture " >
                    <template v-if="inList">
                    <div
                      class="case__picture__case"
                      :style="{backgroundImage:'url('+inList[0]['p_back_logo']+')'}"
                    >
                    </div>
                    </template>
                    <template v-if="inList">
                    <div
                      class="case__picture__award"
                      :style="{backgroundImage:'url('+inList[0]['p_logo']+')'}"
                    ></div>
                    </template>
                  </div>
                  <div class="case__misc">
                    <div class="case__title">
                      <div
                        class="case__title__background"
                        style="background-image: url(' ')"
                      ></div>
                      <template v-if="inList">
                      <h2 class="case__title__content">{{ inList[0]["p_title"]}}</h2>
                      </template>
                    </div>
                    <span class="case__price"><img class="case__price_img" src="../assets/logo.png" alt=""> {{ moneylist | numFilter}}</span>
                  </div>
                  <div
                    class="case__info__arrow"
                    style="
                      background-image: url(' ');
                    "
                  ></div>
                  <div class="case__info__case-number">
                    <div mode="out-in">
                      <div
                        class="case__info__case-number__picture"
                        style="
                          background-image: url(' ');
                        ">
                    </div>
                      <!----><!----><!----><!---->
                    </div>
                  </div>
                </div>
                <div class="case__open-options">
                  <div class="case__open-options__primary">

                    <div class="case__open-options__numbers" >
                      <div
                        class="case__open-options__number "
                        v-for="(item,indexoub) in doubles" :key="indexoub"
                        @click="choiceDouble(indexoub,item)"
                        :class="{'case__open-options__number_active':indexoub==currents}"
                      >
                        <div

                          class="case__open-options__number__background"
                          style="
                            background-image: url('data:image/png;base64,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');
                          "

                        ></div>
                        <span class="case__open-options__number__value">{{indexoub+1}}</span>
                      </div>

                    </div>

                    <div class="case__open-options__buttons">
                      <button class="case__open-options__open" @click="openCase()">
                        <span style="position: relative;z-index: 10;font-size: 18px;" v-if="isrepages">开启中<i class="el-icon-loading" style="font-size: 20px;"></i></span>
                        <span style="position: relative;z-index: 10;font-size: 18px;" v-else>开启({{currents+1}}次)</span>
                        </button
                      >
                      <!-- <button class="case__open-options__try" @click="isopenCase">试玩</button> -->
                    </div>
                  </div>
                  <div style="margin-left: 100px" class="app_case__open">

                    <!-- <div class="case__open-options__sound">
                      <div
                        class="picture-container case__open-options__sound__picture"
                        style="padding-top: 23px; width: 28px"
                      >
                        <div
                          class="picture"
                          style="
                            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAuCAMAAABK1yqqAAAAclBMVEUAAACZmZmZmZmampqZmZmZmZmYmJiZmZmYmJiZmZmbm5uZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiampqampqYmJiZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmampqYmJiZmZmZmZmZmZmZmZmZmZmgSiXzAAAAJXRSTlMAcMwJ1/oV9iLxD1bot6WYfXdgQy0dnZSIY1BL7d+sNMO/c487Op12TQAAAWhJREFUSMelluuSgyAMhSl4t96tbtV2t9vN+7/iOh460zqIcTi/CPhJJoQEsSVV+FKJ42o9IhqOc3VIs06r2TTvWyumCiID+EVE/mjhIkkmMPBpVvi9yQ0xGcE/TJ4DIwWHLDsSZUbs8kMGECqN01BzJiMIdZiO4ezqnzZQaXc6HcT6pJWRHRSXCQvREgyftqTBVN467d0VCwWGO+BAs2QCEkcczpa3Cz6W8R3giJWrELQLSv0tSGyUccCnzhg4+7sYvmKAiQerQmBhNAxQREje27uvJQfU7hHuBa5czgJV/ObraRlLFiju2AXpvIwnHqh3QTVCCvDAdDE9hAprDqCjq/zgjAiO83G4J4B7yrknef9xrSr+tZIw6tVFPl469F9qZrFS62IlSk55LJKP8tgjTgcKcvwqyCtVzBZwtOnkxqYDBY8Dbc69sULjxG/l7o8HSPWbz5WwEVal5gdS92wdn2RWd+2PwH8E6baREDLu8gAAAABJRU5ErkJggg==');
                            background-size: cover;
                          "
                        ></div>
                      </div>
                      <span class="case__open-options__sound__text">音效</span>
                    </div> -->
                    <el-switch
                        v-model="value1"
                        active-text="动画"
                        active-color="#FFBF5A"
                        @change="handdonghua(value1)"
                    >
                    </el-switch>
                    <el-switch
                        v-model="value2"
                        active-text="声音"
                    >
                    </el-switch>
                  </div>
                </div>
              </div>

              <!-- 抽奖组件 -->
                  <Drawprizesimgs :isoutDrawp.sync = 'isDrawpr' :isDrawprimgs='isDrawprimgs' :iscase.sync = 'iscase' :zhongjiang='zhongjiang'
                  :inListadd='inListadd' :value2='value2' :curr='curr' :zhongjiangin="zhongjiangin"
                  ></Drawprizesimgs>

            </div>
            <!-- 中奖轮播图 -->
            <div
              class="app-container app-containers"
              style="margin: 200px auto 10px; justify-content: center"
            >
              <div
                class="picture-container block-title"
                style="padding-top: 4.57054%; width: 44%"
              >
                <div
                  class="picture"
                  style="
                    background-image: url('');
                    background-size: cover;
                    display: flex;align-items: center;justify-content: center;
                  "
                >
                <!-- <img data-v-4459c81f="" src="../assets/img/freeBox/titleI.png" alt=""> -->
                <h1 class="optiwin" style="text-align: center;font-size: 20px;color: #d0d2e0;margin-top: 20px;">最新掉落记录</h1>
                </div>
              </div>
            </div>
            <optimumDrop :newbox='newbox' ref="mychild" :newboxposition='newboxposition' :scrollPosition='scrollPosition'></optimumDrop>

            <div
              class="app-container"
              style="margin: 40px auto 10px; justify-content: center"
            >
              <div
                class="picture-container block-title"
                style="padding-top: 4.57054%; width: 44%"
              >
                <div
                  class="picture"
                  style="
                    background-image: url(' ');
                    background-size: cover;
                  "
                ><h1 style="text-align: center;font-size: 20px;color: #d0d2e0;">箱子包含</h1>
                </div>
              </div>
            </div>
            <div class="awards app-container">
              <!-- <div class="award">
                <div class="award__container">
                  <div class="award__header">
                    <div
                      class="award__picture"
                      style="
                        z-index: 10;
                        background-image: url('http://api.r8skins.com/uploads/20210429/656a3986ffcfaff89a6559571de8e63b.png');
                      "
                    ></div>
                    <div
                      class="award__picture goods_color1"
                      style="background-size: 90%"
                    ></div>
                  </div>
                  <div class="award__content">
                    <h2 class="award__title">
                      系绳匕首（★） | 深红之网 (久经沙场)
                    </h2>
                    <span class="award__property">(久经沙场)</span>
                  </div>
                </div>
                <div class="award__footer">
                  <span class="award__rate">概率:0.53%</span>
                </div>
              </div> -->
              <div class="award content" v-for="(item,index) in inList" :key="index">
                <div class="award__container ">
                  <div class="award__header" :style="{backgroundImage:'url('+item.back_logo+')'}">
                    <div
                      class="award__picture"
                      style="
                        z-index: 10;
                      "
                      :style="{backgroundImage:'url('+item.logo+')'}"
                    ></div>
                    <div
                      class="award__picture goods_color1"
                      style="background-size: 90%;"

                    ></div>
                  </div>
                  <p class="ismoney">{{item.money}}</p>
                  <div class="award__content">
                    <h2 class="award__title">
                      {{item.title}}
                    </h2>
                    <span class="award__property">{{item.type_title}}</span>
                  </div>
                </div>
                <div class="award__footer">
                  <!--2024/4/22隐藏概率-->
<!--                  <span class="award__rate">概率:{{item.odds | numFilter}}%</span>-->
                </div>
              </div>
              <div class="award award_holder"></div>
              <div class="award award_holder"></div>
              <div class="award award_holder"></div>
              <div class="award award_holder"></div>
              <div class="award award_holder"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- <audio id="audio0">
        <source src="/media/audio0.f1e40eb8.wav" type="audio/wav" /></audio
      ><audio id="audio11">
        <source src="/media/audio1.4eaa13d2.mp3" type="audio/mpeg" />
      </audio> -->
    </div>

    <!-- 红包 -->
    <Redenvelopes></Redenvelopes>
    <!-- 抽奖结果 -->
    <Drawpr v-show="isDrawpr" :isoutDrawp.sync = 'isDrawpr' :isdemo='isdemo' :zhongjiangin='zhongjiangin' :summoney.sync='summoney'
    ></Drawpr>

    <!-- 抽奖声音 -->
    <audio id="audios" src="../assets/mp3/2.mp3"></audio>
  </div>
</template>

<script>

import { Switch } from 'element-ui';
import Drawpr from "../components/Drawprizes";
import Drawprizesimgs from "../components/Drawprizesimgs";
import Redenvelopes from "../components/Redenvelopes";
import optimumDrop from "../components/optimumDrop";
export default {
  components: {
      "el-switch":Switch,
      Drawpr,
      Drawprizesimgs,
      Redenvelopes,
      optimumDrop,
  },
  data() {
    return {
      value1: true,//关闭动画
      value2: true,//声音
      doubles:[1,2,3,4,5],//抽奖的倍数
      currents:0,//倍数
      curr:'',//传过去的倍数
      isDrawpr:false,//抽奖提示
      isDrawprimgs:1,//滚动抽奖
      iscase:true,//上面展示的箱子信息
      zhongjiang:'',//中奖信息抽奖页
      zhongjiangin:[],//中奖信息页面
      isdemo:'',//是否试玩
      inList:'',//页面数据
      inListadd:{},//页面数据复制
      isrepages:false,//箱子开启中
      summoney:null,//总价格
      moneylist:'',//页面上的价格
      newbox:[],//箱子最新最佳
      newboxadd:[],//箱子最新最佳旧的
      newboxposition:1,//箱子位置
      scrollPosition:143,//默认首次滚动位置

      // test:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25],//抽奖数据
      // tests:[1,2,3,4,5],//测试
    };
  },
  methods: {

    // 红包
    redPrize(){
      document.getElementsByClassName('ivu-modal')[0].style.display="block";
      document.getElementById('isquan').classList.add("backghui")
    },
    //动画开关
    handdonghua(a){
        this.value1 = a
    },
    //倍数选择
    choiceDouble(index,item){
        //这里要改的话话可以直接传item 不用加1
        // console.log(item);
        this.currents =index
        this.moneylist = this.inList[0]["coin"]  * (index+1)
        //背景图片
        // var im = document.getElementsByClassName('case__info__case-number__picture')[0]
        // im.style.backgroundImage = 'url('+ index +')'
    },
    //开启箱子！！！思路
    openCase(){
      if(localStorage.getItem("token")){
        if(parseFloat(this.$store.state.userdata.coin) > parseFloat(this.inList[0]["coin"]) || parseFloat(this.$store.state.userdata.coin) == parseFloat(this.inList[0]["coin"])){
          //判断是否上一次抽奖是否结束
          if(!this.isrepages){
            this.isrepages = true
            Promise.all([this.getdraw()]).then( () =>{
              // this.isrepages = true
              // this.getdraw()
              //克隆数组   拿到数据的时候判断就可以了
              // if(this.tests.length < 25){
              //   for(var i = 0;i < 45 - this.tests.length;i++){
              //     this.tests.push(this.tests[i]);
              //   }
              // }
              //打乱数组的排列顺序(优化方法 按概率生成)
              // const shuffle = (arr) => {
              //   for (let i = 0; i < arr.length; i++) {
              //     const randomIndex = Math.round(Math.random() * (arr.length - 1 - i)) + i;
              //     [arr[i], arr[randomIndex]] = [arr[randomIndex], arr[i]];
              //   }
              //   return arr;
              // };
              // shuffle(this.tests)
              // this.inListadd.sort(function(){return 0.5 - Math.random()});

              //打乱数组
              this.inListadd.sort(function(){return 0.5 - Math.random()});
              // setTimeout( () =>{  //本来是用延时器的 但是如果用户网络卡 会导致获取不到
              if(this.value1){
                // this.isdemo = true;
                // this.zhongjiang = 66;
                if(this.value2){
                  document.getElementById('audios').load()
                  document.getElementById('audios').play()
                }
                setTimeout( () => { // 设置了一个延时  方便音乐加载
                  this.isDrawprimgs++ //动画触发条件
                  this.iscase = false
                  this.isrepages = false
                },1000)
                // this.isDrawprimgs++ //动画触发条件
                // this.iscase = false //页面动画展示
              }else{
                this.isDrawpr =true
                this.isrepages = false
              }
              // this.isrepages = false
              // },10)
            }).catch(err => {
              // 抛出错误信息
              this.$message({
                type: 'error',
                showClose: true,
                message: '参数错误'
              });
              this.isrepages = false
            });
          }
        }else{
          this.$message({
            showClose: true,
            message: "余额不足",
            type: 'error'
          });
        }
      }else{
        this.$message({
          showClose: true,
          message: '请先登录',
          type: "error",
        });
      }
    },
    //试玩
    // isopenCase(){
    //   if(this.value1){
    //   this.isdemo = false;
    //   this.zhongjiang = 66;
    //   this.isDrawprimgs++
    //   this.iscase = false
    //   if(this.value2){
    //     document.getElementById('audios').load()
    //     document.getElementById('audios').play()
    //   }
    // }else{
    //   this.isDrawpr =true
    // }
    // },

    //获取页面数据
    getinList(){
      this.$axios({
        url:'getShopList',
        method:'post',
        data:{
          p_id:this.$route.query.id
        }
      }).then( res => {
        this.inList = res.data
        this.inListadd =JSON.parse(JSON.stringify(res.data))
        this.moneylist = this.inList[0]["coin"]
        if(this.inListadd.length < 100){
          for(var i = 0;i < 150 - this.inListadd.length;i++){
            this.inListadd.push(this.inListadd[i]);
          }
        }
      })
    },
    //抽奖
    getdraw(){
      //判断是否上一次抽奖是否结束
      // if(!this.isrepages){
        this.curr = this.currents + 1
        return new Promise ((resolve,reject) => {
          this.$axios({
            url:'pond/draw',
            method:'post',
            data:{
              p_id:this.inList[0].p_id,
              count:this.currents + 1
            }
          }).then( res => {
            if(res.data.status == 200){
              //扣除抽奖金额
              let data = parseFloat(this.$store.state.userdata.coin) - (parseFloat(this.inList[0]["coin"]) * (this.currents + 1))
              data = data.toFixed(2)
              this.$store.commit("usercoin_up", data);
              //判断中奖页面
              this.zhongjiangin = res.data.data
              this.summoney = null
              for(let j = 0; j < res.data.data.length;j++){
                for(let a = 0; a < this.inList.length; a++){
                  if(res.data.data[j].id == this.inList[a].id){
                    // this.zhongjiangin.push(this.inList[a])
                    // this.zhongjiangin[j].w_id = res.data.data[j].w_id
                    this.zhongjiangin[j].back_logo = this.inList[a].back_logo
                    this.zhongjiangin[j].logo = this.inList[a].logo
                    this.zhongjiangin[j].money = this.inList[a].money
                    this.zhongjiangin[j].type_title = this.inList[a].type_title
                    this.zhongjiangin[j].p_title = this.inList[a].p_title
                    this.summoney += parseFloat(this.inList[a].money)
                  }
                }
              }
              this.summoney = this.summoney.toFixed(2)
              //判断中奖滚动页面
              // for(let i = 0;i < this.inList.length;i++){
              //   if(this.inList[i].id == res.data.data[0].id){
              //     this.zhongjiang = this.inList[i]
              //   }
              // }
              resolve()
            }else{
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
              //某些原因错误的时候抽奖加载结束
              this.isrepages = false
            }
          // resolve() 为什么不行请求结束后才返回  因为如果错误的话  就不用触发后面的动画和程序了
          })
        }).catch( err => {
          reject()
        })
      // }
    },
    //获取最新最佳箱子掉落
    getnewBoxs(){
      this.$axios({
        url:'monitor/box/Data',
        method:'post',
        data:{
          pid:this.$route.query.id
        }
      }).then( res => {
        if(res.data.status == 200){
          let newboxs =JSON.parse(JSON.stringify(res.data.data))
          // this.newbox = res.data.data
          // console.log(this.newbox);
          // console.log(this.newboxposition);
          for(let i = 0;i < newboxs.length;i++){
            if(newboxs[i].w_id == this.newboxadd.w_id){
              if(i < 5){
                this.newboxposition = i
              }else{
                this.newboxposition = 5
              }
              this.newboxadd = newboxs[0]
              break;
            }
          }
          setTimeout( () => {
            this.newbox = res.data.data
            document.getElementsByClassName("bigop_lis")[0].style.left = -(this.scrollPosition * this.newboxposition) + 'px';
            this.$refs.mychild.small()
          },500)
          //根据元素div大小决定滚动的位置 +10为边框大小(直接获取不到 要在页面渲染数据出来后获取)
          setTimeout( () => {
            this.scrollPosition = document.getElementById('bottomdiv').offsetWidth + 10
          },1000)

        }
      })
    },
    //获取最新最佳箱子掉落
    getnewBoxsadd(){
      this.$axios({
        url:'monitor/box/Data',
        method:'post',
        data:{
          pid:this.$route.query.id
        }
      }).then( res => {
        if(res.data.status == 200){
          this.newboxadd = res.data.data[0]
        }
      })
    },
  },
  mounted(){
    this.getnewBoxs()
  },
  created() {
    this.getinList()
    this.getnewBoxsadd()
    //判断数据是否大于25条inList
    //克隆数组   拿到数据的时候判断就可以了
    // setTimeout( () => {
    //     if(this.inListadd.length < 100){
    //       for(var i = 0;i < 150 - this.inListadd.length;i++){
    //         this.inListadd.push(this.inListadd[i]);
    //       }
    //     }
    // },500)
  },
  filters: {
    numFilter (value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2)
        return realVal
    }
  },
  //监听
  computed: {
    listData() {
      return this.$store.state.newbox
    }
  },
  watch:{
    listData(){
      //触发最新最佳奖品
      this.getnewBoxs()
    }
  }
};
</script>

<style scoped lang='less'>
@import url('../assets/csscopy/indexList.css');

/deep/ .el-switch__label.is-active{
    color: #eee !important;
}
/deep/ .el-switch__label{
    color: #666
}
/deep/ .el-switch:nth-child(1){
    margin-right: 10px;
}
.case__open-options__open{
  border-radius:10px !important;
}
//变成5个一排
.award{
  width: 19% !important;
}
//鼠标移入效果
.award{
  position: relative;
}
.award__header{
  border-radius: 5px;
}
.award:hover{
  .award__header{
    background-image: url('') !important;
  }

}
.award:hover.content{
  background: linear-gradient(
  0deg
  ,rgba(153,0,255,.8),#1f2035);
  border: .0625rem solid #970bff;
}
.ismoney{
  width: 100px;
  opacity: 0;
  text-align: center;
  position: absolute;
  left: calc(50% - 50px);
  bottom: 45%;
  z-index: 99;
  font-size: 20px;
  font-weight: 600;
  color: #f2a046;
  transition: all 0.6s;    //设置动画执行的时间为0.6s
  cursor: pointer;

}
.award:hover .ismoney{
    width: 100px;
    text-align: center;
    opacity: 1;
    position: absolute;
    left: calc(50% - 50px);
    bottom: 45%;
    z-index: 99;
    font-size: 20px;
    font-weight: 600;
    color: #f2a046;
    transform: scale(1.5);
    -webkit-animation: myzoomIn-data-v-125cfc1e .8s;
    animation: myzoomIn-data-v-125cfc1e .8s;
}
.award__header{
  background-size: 100% 100%;
}
@media screen and (max-width: 800px) {
    .award{
      width: 30% !important;
    }
    .page.box-info .case__open-options, .page.box-info .case__open-options__primary{
      flex-wrap: wrap;
    }
    .case__open-options__primary{
      justify-content: space-around;
    }
    .case__open-options__buttons{
      margin-left: 0px !important;
      // padding-top: 20px;
    }
    .app_case__open{
      width: 100%;
      text-align: center;
      margin-left: 0px !important;
      padding-top: 20px;
    }
    .case__title__content{
      padding: 0 !important;
    }
    .case__info{
      justify-content: space-between !important;
    }
    .case__picture{
      width: 40% !important;
    }
    .ismoney{
      width: 100px;
      opacity: 0;
      text-align: center;
      position: absolute;
      left: calc(50% - 50px);
      bottom: 20%;
      z-index: 99;
      font-size: 10px;
      font-weight: 600;
      color: #f2a046;
      transition: all 0.6s;    //设置动画执行的时间为0.6s
      cursor: pointer;

    }
    .award:hover .ismoney{
        width: 100px;
        opacity: 1;
        text-align: center;
        position: absolute;
        left: calc(50% - 50px);
        bottom: 20%;
        z-index: 99;
        font-size: 10px;
        font-weight: 600;
        color: #f2a046;
        transform: scale(1.5);
        -webkit-animation: myzoomIn-data-v-125cfc1e .8s;
        animation: myzoomIn-data-v-125cfc1e .8s;
    }
    .picture-container {
      padding-top: 7.57054% !important;
    }
    .optiwin{
      margin-top: 0px !important;
    }
    .picture{
      align-items: normal !important;
    }
    .app-containers{
      margin-top: 80px !important;
    }
}
//余额图片
.case__price{
  display: flex;
  align-items: center
}
.case__price_img{
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
</style>
